const PDF_CACHE_NAME = 'edu-pdf-preview-v1';
const PDF_CONTENT_TYPE = 'application/pdf';
const PDF_SIGNATURE = '%PDF-';
export function getPdfPreviewStrategy(_request, _environment = {}) {
    return 'canvas-renderer';
}
export function buildPdfPreviewUrl(request) {
    let url = `/api/public/materials/${request.materialId}/preview`;
    if (request.fileName) {
        url = `${url}/${encodeURIComponent(request.fileName)}`;
    }
    if (request.previewToken) {
        return `${url}?token=${encodeURIComponent(request.previewToken)}`;
    }
    if (request.cacheVersion) {
        return `${url}?v=${encodeURIComponent(request.cacheVersion)}`;
    }
    return url;
}
export function buildPdfDownloadUrl(request) {
    const url = `/api/public/materials/${request.materialId}/download`;
    return request.previewToken ? `${url}?token=${encodeURIComponent(request.previewToken)}` : url;
}
export async function loadPdfBlob(request) {
    const cache = shouldReadPersistentCache(request) ? await openPdfCache() : null;
    const key = cache ? cacheKey(request) : null;
    const cached = key ? await cache?.match(key) : undefined;
    if (cached !== undefined) {
        try {
            return await toPdfBlob(await cached.blob());
        }
        catch (error) {
            logPdfCacheWarning(error);
            await cache?.delete(key).catch(logPdfCacheWarning);
        }
    }
    const response = await fetch(pdfBlobFetchUrl(request), { credentials: 'omit' });
    if (!response.ok) {
        throw new Error(`PDF load failed with ${response.status}`);
    }
    const blob = await toPdfBlob(await response.blob());
    if (cache !== null) {
        writePdfCache(cache, request, blob);
    }
    return blob;
}
export function logPdfCacheWarning(error) {
    // eslint-disable-next-line no-console
    console.warn('[pdf-preview] cache warm failed', error);
}
async function openPdfCache() {
    if (!canUsePersistentCache()) {
        return null;
    }
    try {
        return await globalThis.caches.open(PDF_CACHE_NAME);
    }
    catch (error) {
        logPdfCacheWarning(error);
        return null;
    }
}
function canUsePersistentCache() {
    return getLocationOrigin() !== null
        && typeof globalThis.caches !== 'undefined'
        && typeof globalThis.Request !== 'undefined'
        && typeof globalThis.Response !== 'undefined';
}
function shouldReadPersistentCache(request) {
    return !request.previewToken && !!request.cacheVersion;
}
function pdfBlobFetchUrl(request) {
    return request.previewToken ? buildPdfPreviewUrl(request) : buildPdfDownloadUrl(request);
}
function cacheKey(request) {
    const origin = getLocationOrigin();
    if (origin === null) {
        throw new Error('PDF cache key requires a browser location.');
    }
    return new Request(`${origin}/__edu_pdf_preview_cache/${request.materialId}?v=${encodeURIComponent(request.cacheVersion)}`);
}
function writePdfCache(cache, request, blob) {
    try {
        void blob
            .arrayBuffer()
            .then((buffer) => cache.put(cacheKey(request), clonePdfResponse(buffer)))
            .catch(logPdfCacheWarning);
    }
    catch (error) {
        logPdfCacheWarning(error);
    }
}
function getLocationOrigin() {
    if (typeof globalThis.location !== 'undefined') {
        return globalThis.location.origin;
    }
    if (typeof document !== 'undefined') {
        return document.location.origin;
    }
    return null;
}
async function toPdfBlob(blob) {
    const pdfBlob = blob.type === PDF_CONTENT_TYPE ? blob : new Blob([blob], { type: PDF_CONTENT_TYPE });
    await assertPdfSignature(pdfBlob);
    return pdfBlob;
}
async function assertPdfSignature(blob) {
    const header = new TextDecoder().decode(await blob.slice(0, PDF_SIGNATURE.length).arrayBuffer());
    if (header !== PDF_SIGNATURE) {
        throw new Error('PDF blob signature mismatch');
    }
}
function clonePdfResponse(body) {
    return new Response(body, { headers: { 'Content-Type': PDF_CONTENT_TYPE } });
}
//# sourceMappingURL=pdf-preview-source.js.map